import { h } from 'preact';
import AppLayout from './layouts/AppLayout';
import PropTypes from 'prop-types';
import Loading from './ui/Loading';
import store from '../store';

// Actions
import * as firebase from '../firebase';
import * as siteActions from '../actions/site';

function SitesList(props) {
  let { sites } = props;
  const rightAction = {
    name: 'New Site',
    href: '/account/sites/new',
    icon: 'plus',
  };

  if (sites === null) {
    siteActions.remote.findAllForUser();

    return (
      <div className="card">
        <div className="content-padded"><Loading title="Loading sites..." /></div>
      </div>
    );
  }

  if (sites.length === 0) {
    return (
      <div className="card">
        <div className="content-padded">No sites found. Add a site to get started with IncludeCart!</div>
      </div>
    );
  }

  return (
    <AppLayout backUrl={false} title="Sites List" rightAction={rightAction}>
      <div data-component="SitesList">
        <p className="content-padded">Select a site to manage</p>
        <ul className="table-view">
          {sites.map(SiteRow)}
        </ul>
      </div>

      <div className="bar bar-standard bar-footer text-center">
        <a className="btn btn-negative btn-outlined" onClick={() => firebase.remote.logout()}>Log Out</a>
      </div>
    </AppLayout>
  );
}

function SiteRow(site) {
  return (
    <li className="table-view-cell">
      <a className="navigate-right" href={'/account/sites/' + site.id}>
        {site.title}
      </a>
    </li>
  );
}

SitesList.propTypes = {
  sites: PropTypes.array.isRequired,
};

export default store.connect(SitesList, {
  sites: 'local.sites',
  user: 'user',
});
